import { SVGProps, Ref, forwardRef } from 'react'
const SvgColorTwitter = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    width="1.5rem"
    height="1.5rem"
    fill="none"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <path
      fill="#00ACEE"
      d="M24 4.367a9.642 9.642 0 0 1-2.827.795 5.041 5.041 0 0 0 2.164-2.793 9.742 9.742 0 0 1-3.127 1.226A4.862 4.862 0 0 0 16.616 2c-2.72 0-4.924 2.261-4.924 5.048 0 .395.043.781.127 1.15-4.091-.21-7.72-2.22-10.148-5.275a5.118 5.118 0 0 0-.666 2.538c0 1.752.868 3.297 2.19 4.202a4.79 4.79 0 0 1-2.23-.63v.064c0 2.445 1.699 4.487 3.95 4.951a4.828 4.828 0 0 1-2.224.086c.627 2.006 2.445 3.465 4.599 3.507A9.727 9.727 0 0 1 0 19.731 13.7 13.7 0 0 0 7.549 22c9.056 0 14.01-7.694 14.01-14.366 0-.218-.005-.437-.016-.654A10.12 10.12 0 0 0 24 4.367Z"
    />
  </svg>
)
const ForwardRef = forwardRef(SvgColorTwitter)
export default ForwardRef
